export default {
  auth: () => import("/var/lib/go-agent2/pipelines/BuildV2SendxAPPFrontend/go/src/github.com/thebitmonk/sendx/sendx/app_frontend2/layouts/auth.vue").then(m => m.default || m),
  default: () => import("/var/lib/go-agent2/pipelines/BuildV2SendxAPPFrontend/go/src/github.com/thebitmonk/sendx/sendx/app_frontend2/layouts/default.vue").then(m => m.default || m)
}